import React from "react"
import styled from "styled-components"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { renderRichText } from "gatsby-source-contentful/rich-text"

import QuoteIconBlue from "@images/knowledge-center/quote-icon-blue.svg"
import QuoteIconGreen from "@images/knowledge-center/quote-icon-green.svg"
import QuoteIconOrange from "@images/knowledge-center/quote-icon-orange.svg"

// Utils
import { richTextOptions } from "@utils/knowledge-center"

const ArticleQuoteContainer = styled.div`
  .quote-text p {
    font-size: 22px !important;
    line-height: 28px !important;
    color: #2d3748;
    padding-top: 16px;
    margin-top: 0;
  }

  .quote-attribution {
    font-size: 20px;
    line-height: 28px;
    color: var(--grey);
    font-weight: 600;
    margin-top: 16px;
  }

  .quote-context {
    font-size: 16px;
    line-height: 20px;
    color: var(--grey);
    margin-top: 0;
  }
`

const QuoteIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .quote-icon {
    margin-right: 16px;
  }

  .quote-line {
    width: 100%;
    text-align: center;
    border-bottom: ${props => `2px solid ${props.categoryColor}`};
    line-height: 16px;
    margin-top: 0;
  }
`

const ArticleQuote = props => {
  const QuoteIconColor = () => {
    if (props.category === "finances") {
      return QuoteIconGreen
    }
    if (props.category === "mortgages") {
      return QuoteIconBlue
    }
    if (props.category === "homeownership") {
      return QuoteIconOrange
    }
  }

  const CategoryBorderColor = () => {
    if (props.category === "finances") {
      return "#077577"
    }
    if (props.category === "mortgages") {
      return "#007ab4"
    }
    if (props.category === "homeownership") {
      return "#BD432B"
    }
  }

  return (
    <ArticleQuoteContainer className="article-component article-quote">
      <QuoteIconContainer categoryColor={CategoryBorderColor()}>
        <img className="quote-icon" src={QuoteIconColor()} alt="quote icon" />
        <h3 className="quote-line">{""}</h3>
      </QuoteIconContainer>
      <div className="quote-text">
        {renderRichText(props.fields.quote, richTextOptions(props))}
      </div>
      <p className="quote-attribution">{props.fields.attribution}</p>
      {props.fields.context && (
        <div className="quote-context">{props.fields.context}</div>
      )}
    </ArticleQuoteContainer>
  )
}

export default ArticleQuote
